module.exports = __webpack_public_path__ + "static/img/integral.f90b972.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/integral.png
// module id = Ei37
// module chunks = 1